const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

const getAuthHeaders = (walletAddress) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (walletAddress) {
    headers['x-wallet-address'] = walletAddress;
  }
  return headers;
};

const handleResponse = async (response) => {
  if (!response.ok) {
    let errorData;
    try {
      errorData = await response.json();
    } catch (e) {
      errorData = { message: response.statusText || `HTTP error! status: ${response.status}` };
    }
    console.error("API Error Response:", errorData);
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
};


export const getAgentTypes = async () => {
  console.log(`[API Call] Fetching agent types from: ${API_BASE_URL}/agent-types`);
  try {
    const response = await fetch(`${API_BASE_URL}/agent-types`, {
      method: 'GET',
      headers: getAuthHeaders(), 
    });
    return await handleResponse(response);
  } catch (error) {
    console.error("Error fetching agent types:", error.message);
    throw error; 
  }
};


export const getAgentById = async (agentId, walletAddress) => {
  console.log(`[API Call] Fetching agent by ID: ${agentId}`);
  try {
    const response = await fetch(`${API_BASE_URL}/agents/${agentId}`, {
      method: 'GET',
      headers: getAuthHeaders(walletAddress), 
    });
    return await handleResponse(response);
  } catch (error) {
    console.error(`Error fetching agent ${agentId}:`, error.message);
    throw error;
  }
};



export const getAgentsForUser = async (walletAddress) => {
  console.log(`[API Call] Fetching agents for user: ${walletAddress}`);
  if (!walletAddress) {
    console.warn("Attempted to fetch agents without a wallet address.");
    return Promise.reject(new Error("Wallet address is required to fetch user agents."));
  }
  console.log(`[API Call] Fetching agents for user: ${walletAddress}`);
  try {
    const response = await fetch(`${API_BASE_URL}/agents/my-agents`, { 
      method: 'GET',
      headers: getAuthHeaders(walletAddress),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error("Error fetching user agents:", error.message);
    throw error;
  }
};


export const createAgent = async (agentData, userWalletAddress) => {
  if (!userWalletAddress) {
    return Promise.reject(new Error("User wallet address is required to create an agent."));
  }
  console.log(`[API Call] Creating agent for user: ${userWalletAddress}`, agentData);
  try {
    const response = await fetch(`${API_BASE_URL}/agents`, {
      method: 'POST',
      headers: getAuthHeaders(userWalletAddress), 
      body: JSON.stringify(agentData),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error("Error creating agent:", error.message);
    throw error;
  }
};


// export const runAgent = async (agentId, userInput, userWalletAddress) => {
//   if (!userWalletAddress) {
//     return Promise.reject(new Error("User wallet address is required to run an agent."));
//   }
//   console.log(`[API Call] Running agent ${agentId} for user ${userWalletAddress} with input:`, userInput);
//   try {
//     const response = await fetch(`${API_BASE_URL}/agents/${agentId}/run`, {
//       method: 'POST',
//       headers: getAuthHeaders(userWalletAddress), 
//       body: JSON.stringify({ userInput }), 
//     });
//     return await handleResponse(response);
//   } catch (error) {
//     console.error(`Error running agent ${agentId}:`, error.message);
//     throw error;
//   }
// };

export const runAgent = async (agentId, userInput, userWalletAddress) => {
  if (!userWalletAddress) {
    return Promise.reject(new Error("User wallet address is required to run an agent."));
  }
  console.log(`[API Call] Initiating agent run for ${agentId}`);
  try {
    const response = await fetch(`${API_BASE_URL}/agents/${agentId}/run`, {
      method: 'POST',
      headers: getAuthHeaders(userWalletAddress), 
      body: JSON.stringify({ userInput }), 
    });
    // Mengharapkan respons 202 Accepted dengan { taskId }
    return await handleResponse(response);
  } catch (error) {
    console.error(`[API Call Error] Could not initiate agent run for ${agentId}:`, error.message);
    throw error;
  }
};

export const getAgentRunStatus = async (taskId, userWalletAddress) => {
    if (!taskId || !userWalletAddress) {
        return Promise.reject(new Error("Task ID and wallet address are required."));
    }
    try {
        const response = await fetch(`${API_BASE_URL}/agents/run/status/${taskId}`, {
            method: 'GET',
            headers: getAuthHeaders(userWalletAddress),
        });
        return await handleResponse(response);
    } catch (error) {
        console.error(`[API Call Error] Could not get status for task ${taskId}:`, error.message);
        throw error;
    }
};

export const connectWalletAndGetProfile = async (walletAddress, displayName) => {
    console.log(`[API Call] Connecting wallet and fetching profile for: ${walletAddress}`);
    try {
        const response = await fetch(`${API_BASE_URL}/auth/connect-wallet`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify({ walletAddress, displayName }),
        });
        const data = await handleResponse(response);
        return data.user; 
    } catch (error) {
        console.error("Error connecting wallet or fetching profile:", error.message);
        throw error;
    }
};


export const updateAgent = async (agentId, updateData, userWalletAddress) => {
  console.log(`[API Call] Updating agent ${agentId} for user ${userWalletAddress}`, updateData);
  try {
    const response = await fetch(`${API_BASE_URL}/agents/${agentId}`, {
      method: 'PUT',
      headers: getAuthHeaders(userWalletAddress),
      body: JSON.stringify(updateData),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error(`Error updating agent ${agentId}:`, error.message);
    throw error;
  }
};

export const deleteAgent = async (agentId, userWalletAddress) => {
  console.log(`[API Call] Deleting agent ${agentId} for user ${userWalletAddress}`);
  try {
    const response = await fetch(`${API_BASE_URL}/agents/${agentId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(userWalletAddress),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error(`Error deleting agent ${agentId}:`, error.message);
    throw error;
  }
};

export const getDailyAgentActivityChartData = async (walletAddress) => {
  if (!walletAddress) {
    console.warn("Attempted to fetch chart data without a wallet address.");
    return Promise.reject(new Error("Wallet address is required for chart data."));
  }
  console.log(`[API Call] Fetching daily agent activity chart data for: ${walletAddress}`);
  try {
    const response = await fetch(`${API_BASE_URL}/statistics/daily-agent-activity`, { 
      method: 'GET',
      headers: getAuthHeaders(walletAddress), 
    });
    return await handleResponse(response);
  } catch (error) {
    console.error("Error fetching daily agent activity chart data:", error.message);
    throw error;
  }
};